import React from 'react';
import TableRow from '@mui/material/TableRow';
import type { FC, ReactNode } from 'react';

interface TableRowProps {
    id: string;
    children?: ReactNode;
    className?: string;
    hover?:boolean;
    selected?:boolean;
    onClick?: (event: React.MouseEvent<HTMLTableRowElement>) => void
}

const CustomTableRow: FC<TableRowProps> = ({
  id,
  children,
  className,
  hover = false,
  selected = false,
  onClick,
  ...rest
}) => {

  return (
    <TableRow
      id={id}
      className= {className}
      hover= {hover}
      selected= {selected}
      onClick={onClick}
      {...rest}
    >
      {children}
    </TableRow>
  );
}

export default CustomTableRow